module.exports = __webpack_public_path__ + "static/media/ubuntu_logo.57c71ec2.png";